export default __webpack_public_path__ + "static/media/Group 879.360590b7.jpg";